import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IconSearch, IconClose } from './talkAppleIcons';
import './people.css';

export function PersonAvatar({ person, size = 52 }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [person.avatar]);
  return <span className="jt-avatar" style={{ width: size, height: size }} aria-hidden="true">
    {person.avatar && !failed ? <img src={person.avatar} alt="" onError={() => setFailed(true)} /> : (person.username?.trim()[0] || '?').toUpperCase()}
  </span>;
}

export function PeopleHeader({ title, subtitle, children }) {
  return <header className="jt-header"><div><h1>{title}</h1>{subtitle && <p>{subtitle}</p>}</div><div className="jt-header-actions">{children}</div></header>;
}

export function SearchField({ value, onChange, placeholder, label = placeholder }) {
  return <div className="jt-search"><IconSearch size={19} /><input type="search" aria-label={label} placeholder={placeholder} value={value} onChange={event => onChange(event.target.value)} />
    {value && <button data-control="icon" data-control-id="PeopleUI-icon" type="button" onClick={() => onChange('')} aria-label="検索をクリア"><IconClose size={17} /></button>}
  </div>;
}

export function PeopleEmpty({ title, description, to, action, onRetry }) {
  return <div className="jt-empty"><h2>{title}</h2><p>{description}</p>{to && <Link data-control="secondary" data-control-id="PeopleUI-jt-button" className="jt-button" to={to}>{action}</Link>}{onRetry && <button data-control="secondary" data-control-id="PeopleUI-jt-button" className="jt-button jt-button-secondary" onClick={onRetry}>再読み込み</button>}</div>;
}

export function PeopleLoading() {
  return <div className="jt-loading" role="status" aria-label="読み込み中">{[0, 1, 2].map(n => <div className="jt-skeleton" key={n}><span /><div><i /><i /></div></div>)}</div>;
}

const scrollPositions = new Map();
export function usePeopleScroll(key, ready = true) {
  useLayoutEffect(() => {
    // Restore after the rows arrive; a short loading skeleton clamps scrollY.
    if (!ready) return;
    window.scrollTo(0, scrollPositions.get(key) || 0);
    const remember = () => scrollPositions.set(key, window.scrollY);
    window.addEventListener('scroll', remember, { passive: true });
    return () => window.removeEventListener('scroll', remember);
  }, [key, ready]);
}
